import ScriptLoader from '../Core/ScriptLoader';
import Url from '../Core/Url/Url';

export default class Hotjar {
    constructor(options) {
        getUrl = getUrl.bind(this);
        if (!options.hotjarId) throw Error('Id de Hotjar no definido (hotjarId)');
        this.options = options || {};


        this.scriptLoader = new ScriptLoader({
            src: getUrl(),
            inHead: true,
            defer: false
        });


    }



    Load() {
        const sv = this.options.sv || 6;
        window._hjSettings = { hjid: this.options.hotjarId, hjsv: sv };

        this.scriptLoader.Load()
            .then(() => {
            });
    }
}

var getUrl = function()  {
    const sv = this.options.sv || 6;
    return Url.FromProtocol('https:',`static.hotjar.com/c/hotjar-${this.options.hotjarId}.js?sv=${sv}`);
}


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/Hotjar.js